// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2TIQ2","inner":"Form_inner__3tKV1","range":"Form_range__2IG24","name":"Form_name__3wsyy","actions":"Form_actions__1I9Pc"};